module.exports = __webpack_public_path__ + "img/care-service.15330d38.svg";